export default () => {
  return (
    <div className="team-banner">
      <div className="team-banner-image" />
    </div>
  );
};
